module.exports = __webpack_public_path__ + "img/falso-verdadero.7383bc94.svg";